import SearchInput from "./SearchInput";
import "./SearchInput.scss";

export default SearchInput;